<template>
    <div class="clear-selection-button-container" :class="{ shown: isShown }">
        <VButton class="clear-selection-button warning rounded">
            {{ translations.bill.clearSelection }}
        </VButton>
    </div>
</template>

<script setup lang="ts">
    import { translations } from "@/shared/localization/translations";
    import { computed } from "vue";

    import VButton from "@/components/elements/VButton.vue";

    // define properties
    const props = defineProps<{
        isShown?: boolean;
    }>();

    // define computed
    const isShown = computed(() => (props.isShown === undefined ? true : props.isShown));
</script>

<style scoped lang="scss">
    .clear-selection-button-container {
        position: absolute;
        top: -44px;
        left: 50%;
        opacity: 0;
        transform: translate(-50%, 26px);
        transition:
            opacity 0.2s ease-out,
            transform 0.3s cubic-bezier(0.47, 0.06, 0.31, 1.23);

        &.shown {
            opacity: 1;
            transform: translate(-50%, 0);
        }

        .clear-selection-button {
            font-size: 12px;
            -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
            -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
            box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.25);
            white-space: nowrap;
        }
    }
</style>
